import { getValidClassNames } from "@/utils";
import { InformationBanner } from "../../InformationBanner";
import { EFeedbackProgress, FeedbackResultCardProps } from "./FeedbackResultCard.interfaces";


export const FeedbackResultCard = ({ answer, icon, informationBanner, progress, question, title  }: FeedbackResultCardProps) => {
  return(
    <div className="flex flex-col md:flex-row gap-4 items-start border border-grey-300 rounded-md bg-white px-6 py-5 shadow-xl">
      {icon && (
        <img className="w-16" src={icon} alt="Alcohol" />
      )}

      <div className="flex flex-col gap-5">
        <div className="flex gap-4">
          <div>
            <span className="h5 color-red-500">{title}</span>
            <p className="h3">Results</p>
          </div>
        </div>

        <div className="flex border border-grey-400 rounded-lg overflow-hidden">
          <div className={getValidClassNames({
            "w-1/3 px-4 py-3 text-uppercase text-center flex items-center justify-center border-r border-grey-400": true,
            "bg-red-200": progress === EFeedbackProgress.Low
          })}>
            <p className="text-sm weight-800">Action needed</p>
          </div>
          <div className={getValidClassNames({
            "w-1/3 px-4 py-3 text-uppercase text-center flex items-center justify-center border-r border-grey-400": true,
            "bg-orange-200": progress === EFeedbackProgress.Medium
          })}>
            <p className="text-sm weight-800">Need more work</p>
          </div>
          <div className={getValidClassNames({
            "w-1/3 px-4 py-3 text-uppercase text-center flex items-center justify-center": true,
            "bg-primary": progress === EFeedbackProgress.High
          })}>
            <p className="text-sm weight-800">Going strong</p>
          </div>
        </div>

        <p>{question} <strong>{answer}</strong></p>

        {informationBanner && (
          <InformationBanner 
            {...informationBanner}
          />
        )}
      
      </div>
    </div>
  )
};